import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { toNumber } from 'lodash';
import { useGetFundReportQuery } from '~/types/types';
import { renderMarkdown } from '~/functions/markdown';
import { sfdrTreeviewNames } from '~/functions/sfdr';
import { getLocale } from '~/functions/translate';
export default /*#__PURE__*/_defineComponent({
  __name: 'SustainableObjectiveTree',
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var route = useRoute();
    var locale = computed(function () {
      return getLocale();
    });
    var _useGetFundReportQuer = useGetFundReportQuery(computed(function () {
        return {
          input: {
            id: toNumber(route.params.fund),
            referencePeriodId: toNumber(route.query.referencePeriodId)
          }
        };
      }), computed(function () {
        var _route$query;
        return {
          enabled: !!((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.referencePeriodId) && !!route.params.fund
        };
      })),
      calculatedSfdrReportResult = _useGetFundReportQuer.result;
    var calculatedSfdrReport = computed(function () {
      var _calculatedSfdrReport;
      return ((_calculatedSfdrReport = calculatedSfdrReportResult.value) === null || _calculatedSfdrReport === void 0 ? void 0 : _calculatedSfdrReport.getFundReport) || {
        nameOfFinancialMarketParticipant: '',
        legalEntityIdentifier: ''
      };
    });
    var hasEsCharacteristics = computed(function () {
      var _calculatedSfdrReport2, _calculatedSfdrReport3;
      // %%PROMOTED_ES%%
      var text = sfdrTreeviewNames.hasEsCharacteristics[locale.value];
      var value = (_calculatedSfdrReport2 = (_calculatedSfdrReport3 = calculatedSfdrReport.value) === null || _calculatedSfdrReport3 === void 0 ? void 0 : _calculatedSfdrReport3.percentSustainableInvestmentsWhilePromotingEsCharacteristics) !== null && _calculatedSfdrReport2 !== void 0 ? _calculatedSfdrReport2 : 0;
      return text.replace(/%%PROMOTED_ES%%/g, value.toString());
    });
    var hasSustainableInvestmentWithEnvironmentalObjective = computed(function () {
      var _calculatedSfdrReport4, _calculatedSfdrReport5;
      var text = sfdrTreeviewNames.hasSustainableInvestmentWithEnvironmentalObjective[locale.value];
      var value = (_calculatedSfdrReport4 = (_calculatedSfdrReport5 = calculatedSfdrReport.value) === null || _calculatedSfdrReport5 === void 0 ? void 0 : _calculatedSfdrReport5.percentSustainableInvestmentsWithEnvironmentalObjective) !== null && _calculatedSfdrReport4 !== void 0 ? _calculatedSfdrReport4 : 0;
      return text.replace(/%%ENV_OBJ%%/g, value.toString());
    });
    var hasSustainableInvestmentWithSocialObjective = computed(function () {
      var _calculatedSfdrReport6, _calculatedSfdrReport7;
      var text = sfdrTreeviewNames.hasSustainableInvestmentWithSocialObjective[locale.value];
      var value = (_calculatedSfdrReport6 = (_calculatedSfdrReport7 = calculatedSfdrReport.value) === null || _calculatedSfdrReport7 === void 0 ? void 0 : _calculatedSfdrReport7.percentSustainableInvestmentsWithSocialObjective) !== null && _calculatedSfdrReport6 !== void 0 ? _calculatedSfdrReport6 : 0;
      return text.replace(/%%SOC_OBJ%%/g, value.toString());
    });
    var formTreeViews = computed(function () {
      var _calculatedSfdrReport8, _calculatedSfdrReport9, _calculatedSfdrReport10, _calculatedSfdrReport11, _calculatedSfdrReport12, _calculatedSfdrReport13, _calculatedSfdrReport14, _calculatedSfdrReport15, _calculatedSfdrReport16, _calculatedSfdrReport17, _calculatedSfdrReport18, _calculatedSfdrReport19, _calculatedSfdrReport20, _calculatedSfdrReport21, _calculatedSfdrReport22, _calculatedSfdrReport23, _calculatedSfdrReport24, _calculatedSfdrReport25, _calculatedSfdrReport26, _calculatedSfdrReport27, _calculatedSfdrReport28, _calculatedSfdrReport29;
      var trees = {
        // ARTICLE 9 SIDE
        hasSustainableInvestmentObjective: [{
          id: 'hasSustainableInvestmentWithEnvironmentalObjective',
          name: hasSustainableInvestmentWithEnvironmentalObjective.value,
          disabled: !((_calculatedSfdrReport8 = calculatedSfdrReport.value) !== null && _calculatedSfdrReport8 !== void 0 && _calculatedSfdrReport8.isArticle9),
          selected: ((_calculatedSfdrReport9 = calculatedSfdrReport.value) === null || _calculatedSfdrReport9 === void 0 ? void 0 : _calculatedSfdrReport9.hasEnvironmentalInvestments) && ((_calculatedSfdrReport10 = calculatedSfdrReport.value) === null || _calculatedSfdrReport10 === void 0 ? void 0 : _calculatedSfdrReport10.isArticle9),
          children: [{
            id: 'hasEnvironmentalObjectiveEnvironmentallySustainableUnderEuTaxonomy',
            name: sfdrTreeviewNames.hasEnvironmentalObjectiveEnvironmentallySustainableUnderEuTaxonomy[locale.value],
            disabled: !((_calculatedSfdrReport11 = calculatedSfdrReport.value) !== null && _calculatedSfdrReport11 !== void 0 && _calculatedSfdrReport11.isArticle9),
            selected: ((_calculatedSfdrReport12 = calculatedSfdrReport.value) === null || _calculatedSfdrReport12 === void 0 ? void 0 : _calculatedSfdrReport12.hasAlignedEnvironmentalInvestments) && ((_calculatedSfdrReport13 = calculatedSfdrReport.value) === null || _calculatedSfdrReport13 === void 0 ? void 0 : _calculatedSfdrReport13.isArticle9)
          }, {
            id: 'hasEnvironmentalObjectiveNonEnvironmentallySustainableUnderEuTaxonomy',
            name: sfdrTreeviewNames.hasEnvironmentalObjectiveNonEnvironmentallySustainableUnderEuTaxonomy[locale.value],
            disabled: !((_calculatedSfdrReport14 = calculatedSfdrReport.value) !== null && _calculatedSfdrReport14 !== void 0 && _calculatedSfdrReport14.isArticle9),
            selected: ((_calculatedSfdrReport15 = calculatedSfdrReport.value) === null || _calculatedSfdrReport15 === void 0 ? void 0 : _calculatedSfdrReport15.hasNonAlignedEnvironmentalInvestments) && ((_calculatedSfdrReport16 = calculatedSfdrReport.value) === null || _calculatedSfdrReport16 === void 0 ? void 0 : _calculatedSfdrReport16.isArticle9)
          }]
        }, {
          id: 'hasSustainableInvestmentWithSocialObjective',
          name: hasSustainableInvestmentWithSocialObjective.value,
          disabled: !((_calculatedSfdrReport17 = calculatedSfdrReport.value) !== null && _calculatedSfdrReport17 !== void 0 && _calculatedSfdrReport17.isArticle9),
          selected: ((_calculatedSfdrReport18 = calculatedSfdrReport.value) === null || _calculatedSfdrReport18 === void 0 ? void 0 : _calculatedSfdrReport18.hasSocialObjective) && ((_calculatedSfdrReport19 = calculatedSfdrReport.value) === null || _calculatedSfdrReport19 === void 0 ? void 0 : _calculatedSfdrReport19.isArticle9)
        }],
        // ARTICLE 8 AND 8+ SIDE
        hasNoSustainableInvestmentObjective: [{
          id: 'hasEsCharacteristics',
          name: hasEsCharacteristics.value,
          disabled: (_calculatedSfdrReport20 = calculatedSfdrReport.value) === null || _calculatedSfdrReport20 === void 0 ? void 0 : _calculatedSfdrReport20.isArticle9,
          selected: (_calculatedSfdrReport21 = calculatedSfdrReport.value) === null || _calculatedSfdrReport21 === void 0 ? void 0 : _calculatedSfdrReport21.isArticle8Plus,
          children: [{
            id: 'hasEsCharacteristicsAndEnvironmentalObjectiveSustainableUnderEuTaxonomy',
            name: sfdrTreeviewNames.hasEsCharacteristicsAndEnvironmentalObjectiveSustainableUnderEuTaxonomy[locale.value],
            disabled: (_calculatedSfdrReport22 = calculatedSfdrReport.value) === null || _calculatedSfdrReport22 === void 0 ? void 0 : _calculatedSfdrReport22.isArticle9,
            selected: (_calculatedSfdrReport23 = calculatedSfdrReport.value) === null || _calculatedSfdrReport23 === void 0 ? void 0 : _calculatedSfdrReport23.isArticle8PlusWithAlignedEnvironmentalInvestments
          }, {
            id: 'hasEsCharacteristicsAndEnvironmentalObjectiveNonSustainableUnderEuTaxonomy',
            name: sfdrTreeviewNames.hasEsCharacteristicsAndEnvironmentalObjectiveNonSustainableUnderEuTaxonomy[locale.value],
            disabled: (_calculatedSfdrReport24 = calculatedSfdrReport.value) === null || _calculatedSfdrReport24 === void 0 ? void 0 : _calculatedSfdrReport24.isArticle9,
            selected: (_calculatedSfdrReport25 = calculatedSfdrReport.value) === null || _calculatedSfdrReport25 === void 0 ? void 0 : _calculatedSfdrReport25.isArticle8PlusWithNonAlignedEnvironmentalInvestments
          }, {
            id: 'hasEsCharacteristicsAndSocialObjective',
            name: sfdrTreeviewNames.hasEsCharacteristicsAndSocialObjective[locale.value],
            disabled: (_calculatedSfdrReport26 = calculatedSfdrReport.value) === null || _calculatedSfdrReport26 === void 0 ? void 0 : _calculatedSfdrReport26.isArticle9,
            selected: (_calculatedSfdrReport27 = calculatedSfdrReport.value) === null || _calculatedSfdrReport27 === void 0 ? void 0 : _calculatedSfdrReport27.isArticle8PlusWithSocialObjective
          }]
        }, {
          id: 'hasEsCharacteristicsWithoutSustainableInvestment',
          name: sfdrTreeviewNames.hasEsCharacteristicsWithoutSustainableInvestment[locale.value],
          disabled: (_calculatedSfdrReport28 = calculatedSfdrReport.value) === null || _calculatedSfdrReport28 === void 0 ? void 0 : _calculatedSfdrReport28.isArticle9,
          selected: (_calculatedSfdrReport29 = calculatedSfdrReport.value) === null || _calculatedSfdrReport29 === void 0 ? void 0 : _calculatedSfdrReport29.isArticle8
        }]
      };
      return trees;
    });
    return {
      __sfc: true,
      route: route,
      locale: locale,
      calculatedSfdrReportResult: calculatedSfdrReportResult,
      calculatedSfdrReport: calculatedSfdrReport,
      hasEsCharacteristics: hasEsCharacteristics,
      hasSustainableInvestmentWithEnvironmentalObjective: hasSustainableInvestmentWithEnvironmentalObjective,
      hasSustainableInvestmentWithSocialObjective: hasSustainableInvestmentWithSocialObjective,
      formTreeViews: formTreeViews,
      renderMarkdown: renderMarkdown
    };
  }
});